export default __webpack_public_path__ + "static/0072-c5507029409ecf462d085219c8596d65.png";